import { lazy, Suspense, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Loading from "../../../components/comComponents/Loading";
import Header from "../../../components/header/Header";
import { chkOsType, osDetail } from "../../../modules/Common";
import { ErrorModule } from "../../../modules/ErrorModule";
import { callOpenApiNonAuth } from "../../../modules/TokenBase";

const Index = () =>{
    const navigate = useHistory();
    const [complete, setComplete] = useState(false); //화면 전환
    const [alertContents, setAlertContents] = useState(''); //알림 내용
    const [alertIcon, setAlertIcon] = useState(''); //알림 아이콘
    const [alertOpen, setAlertOpen] = useState(false); //알림 오픈 여부
    const [goMain, setGoMain] = useState(false);// 알림 팝업 닫은 후 추가 액션을 취하고 싶을때 추가
    const [loadOpen, setLoadOpen] = useState(false); //로딩 여부

    const OneBtnAlert = lazy(()=> import('../../../components/comComponents/OneBtnAlert'));
    
    const startScraping = () =>{
        setLoadOpen(true);
        const param = {
            "bzn" : sessionStorage.getItem('docBizNo'),
            "userChnlNm": btoa(encodeURIComponent(chkOsType())),
            "userTrunCon": btoa(encodeURIComponent(osDetail()))
        }
        callOpenApiNonAuth("/api/cm/v1/cms010/docSbmsRqstCrt", param, function( result ){
            setLoadOpen(false);
            if(result.STATUS == "0000"){
                var data = result.RSLT_DATA;
                if(data.docSbmsId){
                    setComplete(true);
                }else{
                    setGoMain(true);
                    setAlertIcon("F");
                    setAlertContents(result.RSLT_MSG)
                    alertFun(true);
                }
            }else{
                setGoMain(true);
                setAlertIcon("F");
                setAlertContents(result.RSLT_MSG)
                alertFun(true);
            }
        },function (e) {
            setLoadOpen(false);
            let param = ErrorModule(e);
            if(param) {
                setGoMain(true);
                setAlertIcon("F");
                setAlertContents("["+e.responseJSON.msgCd+"]"+e.responseJSON.mnmsgCntn);
                alertFun(true);
            }
        });
        
    }

    //알림 오픈 함수
    const alertFun = (open) => {
        setAlertOpen(open);

        //아래 코드는 알림팝업 닫은 후 실행할 추가 액션 코드(메인화면으로 이동)
        if(!open){
            if(goMain){
                sessionStorage.clear();
                navigate.push('/');
            }
        }
    }

    useEffect(()=>{
        if(sessionStorage.getItem('docBizNo')){
            if(sessionStorage.getItem('docEntryType') === "certCenter"){
                startScraping();
            }else{
                setComplete(true);
            }

        }else{
            setGoMain(true);
            setAlertIcon("F");
            setAlertContents("부정한접근입니다.")
            alertFun(true);
        }
    },[])
    return(
        <div>
            <Header headerTitle="서류제출" arrowYn={false} closeYn={false}/>
            {complete ?
            <div id="container">		
                <div className="content">			
                    <div className="vhBox bottomBtn mHeight500 ">			
                        <div className="innerBox">
                            <div className="IconWrap">
                                {/* 아이콘 리스트
                                기본 = default , 안내 = .guidance , 실패 = .fail , 성공 = .success */}
                                <div className="icon success"></div>
                                <p className="mediumTit txtBold">
                                    서류제출 신청이<br/>완료되었습니다.
                                </p>
                                <p className="normalTit txtBlack2 mt24 pl20 pr20">
                                    영업점에서 제출된 서류 확인까지<br/>
                                    최대 3일정도 소요될 수 있습니다.
                                </p>
                                <p className="normalTit txtBlack2 mt16 pl20 pr20">
                                    서류 제출이 정상적으로<br/>
                                    완료되지 않은 경우 고객님께<br/>
                                    다시 연락을 드릴 수 있는 점<br/>
                                    양해 부탁 드리겠습니다.
                                </p>
                                <p className={sessionStorage.getItem('docSbmsReqYn')=="Y"?"smallTit txtRed3 mt16 pl20 pr20":"dpNone"}>
                                    ※ 중복 서류제출 방지를 위해<br/>
                                    동일자 30분 이내 수행하신 경우,<br/>
                                    새로운 서류제출이 생략됩니다.
                                </p>
                            </div>
                        </div>
                    </div>		
                </div>

                <div className="fullbtn">
                    <Link to="/" className="btn on">확인</Link>
                </div>
            </div>
            :
            <></>
            }
            <Suspense fallback={<></>}>
                {alertOpen ? <OneBtnAlert alertContents={alertContents} alertOpen={alertOpen} alertFun={alertFun} alertIcon={alertIcon}/> : <></>}
            </Suspense>
            <Loading loadOpen={loadOpen}/>
        </div>
    );
}
export default Index;